import 'css-chunksrc/client/scenes/event/participantsList/resource/user/styles.scss';export default {
  "resource": "_resource_10hij_1",
  "user": "_user_10hij_12",
  "avatar": "_avatar_10hij_24",
  "name": "_name_10hij_36",
  "title": "_title_10hij_42"
};